import React from 'react'
//import Link from 'gatsby-link'

const Header = ({ siteTitle }) => (
<div></div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js